import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackDemoIntent, trackPageView } from '@/lib/tracking';

/**
 * Medición global de navegación y de intención de demo.
 *
 * Se monta una sola vez en el router, de modo que cualquier CTA que lleve a la
 * página de demo —menú, portada, precios, sectores, blog, pie— quede contado sin
 * tener que instrumentar botón a botón.
 */
export default function ConversionTracker() {
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);
  const lastClick = useRef(null);

  // Guardamos el último botón o enlace pulsado para poder atribuir el evento al
  // CTA concreto y no solo a la página de origen.
  useEffect(() => {
    const onClick = (e) => {
      const target = e.target?.closest?.('a, button');
      if (!target) return;
      lastClick.current = (target.textContent || '').trim().slice(0, 60);
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  useEffect(() => {
    const from = previousPath.current;
    if (pathname === '/demo' && from !== '/demo' && lastClick.current) {
      trackDemoIntent({ from, button: lastClick.current });
    }
    previousPath.current = pathname;
    lastClick.current = null;
    trackPageView(pathname);
  }, [pathname]);

  return null;
}